import InputMulti from './InputMulti';

export default InputMulti;
